'use client';

import { useEffect } from 'react';

export function LandingBodyClass() {
  useEffect(() => {
    document.body.classList.add('landing-midnight');
    return () => {
      document.body.classList.remove('landing-midnight');
    };
  }, []);

  return null;
}
